// lsp及开放平台内嵌twinsmt项目的多环境地址
const twPageUrl = () => {
  const origin = window.location.origin
  let baseURL = ''
  if (origin.includes('dev')) {
    baseURL = 'https://twinsmt.dev.iol8.net'
  } else if (origin.includes('qa')) {
    baseURL = 'https://twinsmt.qa.iol8.net'
  } else if (origin.includes('release')) {
    baseURL = 'https://twinsmt.release.iol8.net'
  } else if (origin.includes('iol8.com')) {
    baseURL = 'https://twinsmt.iol8.com'
  } else if (origin.includes('localhost')) {
    baseURL = 'https://twinsmt.dev.iol8.net'
  }
  return baseURL
}

export { twPageUrl }
